import { Component, ElementRef, HostBinding, HostListener, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, Input } from '@angular/core';
import {
  Account,
  AccountService,
  ConfigService,
  GroupOrder,
  GroupOrderService,
  HypermediaService,
  Order,
  OrderableItem,
  OrderableItemService,
  OrderedItem,
  OrderedItemService,
  OrderedSpecial,
  OrderService,
  OrderSpecialService,
  SizePrice,
  StoreConfig,
  Utils,
  UpsellType,
  AuditService,
  OrderedIngredientService,
  OrderableCoupon,
  Coupon,
  DeferOptions,
  DeferService,
  TimezoneService,
} from 'ngx-web-api';
import { Observable, of, Subscription, noop, combineLatest, EMPTY } from 'rxjs';
import { delay, filter, map, mergeMap, skip, switchMap, take, tap } from 'rxjs/operators';
import { UiOrchestratorService } from '../../core/services/ui-orchestrator.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { ItemEditorService } from 'app/core/services/item-editor.service';
import { faTimes } from '@fortawesome/pro-light-svg-icons/faTimes';
import { ViewportService } from 'app/core/services/viewport.service';
import { ModalService } from 'app/core/services/modal.service';
import { OrderUpsellService } from 'app/core/services/order-upsell.service';
import { PathService } from '../services/path.service';
import { FtsCurrencyPipe } from '../pipes/fts-currency.pipe';
import { GTMService } from '../../core/services/gtm.service';
import { EcommerceTriggeringArea } from '../../domain/ecommerce-triggering-area.enum';
import { ThemeService } from '../../core/services/theme.service';
import { Theme } from '../../domain/theme.model';
import { ViewPort } from '../../domain/view-port.model';
import { FocusService } from 'app/focus.service';
import { Router } from '@angular/router';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { addDays, format, formatISO, parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

@Component({
  selector: 'fts-order-notification',
  templateUrl: './order-notification.component.html',
  styleUrls: ['./order-notification.component.scss'],
})
export class OrderNotificationComponent implements OnInit, OnDestroy {
  order: Order;
  groupOrder: GroupOrder;
  notificationItem?: OrderedItem;
  notificationSpecial?: OrderedSpecial;
  notificationIsAddition = false;
  notificationIsUpdate = false;
  upsellSizeSubscription: Subscription;
  upsellIngredientSubscription: Subscription;
  notificationCoupon: Coupon;
  showCouponInstructionsBtn = false;
  account: Account;
  upsellingSizeCalories?: string;
  faRemove = faTimes;
  infoMessage: string;
  upsellBtnLabel: string;
  inOrderDetails$: Observable<boolean>;
  theme: Theme;
  viewport: ViewPort;
  updatedOrderDeferTime: string = '';
  deferTimeWeekdayName: string = '';
  hasCateringNoticeTime: boolean;

  @Input() rightPosition: string;
  @Input() maxWidth: string;
  @HostBinding('style.marginBottom.px')
  protected readonly bottomMargin = -1;

  @ViewChild('notificationWrapper', { static: false })
  private notificationWrapper: ElementRef;

  @ViewChild('continueShoppingBtn', { static: false })
  private continueShoppingBtn: ElementRef;

  public showUpsizeDoneMessage = false;
  public showUpingredientDoneMessage = false;
  public hideIngrUpsellAfterSizeUp = false;
  public theme$: Observable<Theme>;
  private subscriptions: Subscription[];
  orderTreeIsOpen: boolean;
  private readonly DELAY = 5000;
  private dismissNotificationTimeout: any;
  faExclamationCircle = faExclamationCircle;

  constructor(
    private orderService: OrderService,
    private orderedItemService: OrderedItemService,
    private orderSpecialService: OrderSpecialService,
    private groupOrderService: GroupOrderService,
    private configService: ConfigService,
    private hypermedia: HypermediaService,
    private orderableItemService: OrderableItemService,
    private uiOrchestrationService: UiOrchestratorService,
    private accountService: AccountService,
    private auditService: AuditService,
    private translateService: TranslateService,
    private http: HttpClient,
    private orderedIngredientService: OrderedIngredientService,
    private itemEditorService: ItemEditorService,
    public viewportService: ViewportService,
    private currencyPipe: FtsCurrencyPipe,
    private modalService: ModalService,
    private cdRef: ChangeDetectorRef,
    private orderUpsellService: OrderUpsellService,
    private pathService: PathService,
    private gtmService: GTMService,
    private themeService: ThemeService,
    private focusService: FocusService,
    private router: Router,
    private deferService: DeferService,
    private timezoneService: TimezoneService
  ) {
    this.inOrderDetails$ = this.pathService.inOrderDetails$;
    this.theme$ = this.themeService.theme;
  }

  ngOnInit() {
    this.configService.storeConfig$.subscribe((config: StoreConfig) => (this.hasCateringNoticeTime = config?.hasCateringNoticeTime));
    this.modalService.couponNotify$.subscribe(coupon => {
      if (!!coupon) {
        this.notificationCoupon = coupon;
        if (!coupon.name) {
          coupon.name = '';
        }
        if (!!coupon.instructions) {
          this.showCouponInstructionsBtn = true;
        }

        this.cdRef.detectChanges();
        this.focusContinueShoppingButton();
      }
    });
    this.subscriptions = [
      this.viewportService.viewport$.subscribe(viewport => (this.viewport = viewport)),
      this.themeService.theme.subscribe(theme => (this.theme = theme)),
      this.uiOrchestrationService.orderTreeIsOpen$.subscribe(isOpen => {
        this.orderTreeIsOpen = isOpen;
        if (this.orderTreeIsOpen) {
          this.dismissNotification();
        } else this.cdRef.detectChanges();
      }),
      this.orderService.order$
        .pipe(
          tap(order => {
            if (this.order?.specials?.length && !order.specials?.length && (!!this.notificationCoupon || !!this.notificationSpecial)) {
              this.dismissNotification();
            }
          })
        )
        .subscribe(order => (this.order = order)),
      this.groupOrderService.groupOrder$.subscribe(g => (this.groupOrder = g)),
      this.accountService.account$.subscribe(account => (this.account = account)),

      this.orderUpsellService.addedOrderableItem$
        .pipe(
          mergeMap((orderableItem: OrderableItem) =>
            this.orderedItemService.addedItem$.pipe(
              map((item: OrderedItem) => [item, orderableItem]),
              take(1)
            )
          ),
          filter(([item, orderableItem]) => orderableItem.name === item.item && orderableItem.category === item.category),
          mergeMap(([item, orderableItem]: [OrderedItem, OrderableItem]) =>
            this.findUpsellingSizePriceCalories(item, orderableItem).pipe(
              map((upsellingSizeCalories: string) => ({
                item,
                upsellingSizeCalories,
              }))
            )
          )
        )
        .subscribe(({ item, upsellingSizeCalories }) => {
          this.notificationIsUpdate = false;
          this.notificationIsAddition = true;
          this.notificationItem = item;
          this.generateUpsellBtnLabel();
          this.generateInfoMessage();
          this.upsellingSizeCalories = upsellingSizeCalories;

          setTimeout(() => {
            if (!!this.notificationWrapper?.nativeElement) {
              this.focusService.activateFocusTrap(this.notificationWrapper?.nativeElement);
              if (this.continueShoppingBtn?.nativeElement) {
                this.continueShoppingBtn.nativeElement.focus();
              } else {
                this.notificationWrapper.nativeElement.focus();
              }
            }
          }, 500);
        }),

      this.orderedItemService.addedItem$
        .pipe(
          switchMap(item => {
            if (
              item?.noticePeriod <= this.order?.noticePeriod ||
              !this.hasCateringNoticeTime ||
              (this.groupOrder?.isActive && !this.groupOrder?.asLeader)
            ) {
              return of({ item, timeslots: [] });
            }

            return this.orderService.order$.pipe(
              skip(1),
              take(1),
              switchMap(freshOrder =>
                this.resolveNoticePeriodTimeslots(freshOrder.noticePeriodDate).pipe(map(timeslots => ({ item, timeslots })))
              )
            );
          }),
          switchMap(({ item, timeslots }) => {
            if (!timeslots?.length) {
              return of({ item, updated: false });
            }

            const timeslotDate = parseISO(timeslots[0]);
            const deferTimeDate = parseISO(this.order.deferTime);

            const isLater = this.order.deferTime ? timeslotDate.getTime() > deferTimeDate.getTime() : true;

            const closeTime = this.deferService.storeStatus?.closeTime;
            const isNextDay = closeTime
              ? timeslotDate > parseISO(closeTime)
              : timeslotDate.toDateString() !== Utils.getTzDate().toDateString();

            if (isNextDay) {
              this.deferTimeWeekdayName = formatInTimeZone(timeslotDate, this.timezoneService.getTimeZone(), 'EEEE');
            }

            if (isLater && item?.noticePeriod > 0) {
              const orderCopy = this.order ? this.order.copy() : new Order();
              orderCopy.deferTime = timeslots[0];
              const date = parseISO(timeslots[0]);
              const storeTimezone = this.timezoneService.getTimeZone();
              this.updatedOrderDeferTime = formatInTimeZone(date, storeTimezone, 'h:mm a');
              if (this.order.isInitialized && !this.groupOrder?.isActive) {
                return this.orderService.updateOrder(orderCopy).pipe(map(() => ({ item, updated: true })));
              } else {
                if (this.order.isInitialized && this.groupOrder?.asLeader) {
                  return this.orderService.updateOrder(orderCopy).pipe(map(() => ({ item, updated: true })));
                }
              }
            }

            return of({ item, updated: false });
          })
        )
        .subscribe(({ item }) => {
          this.showUpsizeDoneMessage = false;
          this.showUpingredientDoneMessage = false;
          this.notificationIsUpdate = false;
          this.notificationIsAddition = true;
          this.notificationItem = item;
          this.generateUpsellBtnLabel();
          this.generateInfoMessage();
          this.focusService.deactivateFocusTrap();

          if (this.dismissNotificationTimeout) {
            clearTimeout(this.dismissNotificationTimeout);
          }

          this.focusContinueShoppingButton();

          this.dismissNotificationTimeout = setTimeout(() => {
            if (this.notificationItem) {
              this.dismissNotification();
            }
          }, this.DELAY);
        }),

      combineLatest([this.orderedItemService.updatedItem$, this.orderUpsellService.addedOrderableItem$])
        .pipe(
          filter(([item, orderableItem]) => orderableItem.name === item.item && orderableItem.category === item.category),
          mergeMap(([item, orderableItem]) =>
            this.findUpsellingSizePriceCalories(item, orderableItem).pipe(
              map((upsellingSizeCalories: string) => ({
                item,
                upsellingSizeCalories,
              }))
            )
          )
        )
        .subscribe(({ item, upsellingSizeCalories }) => {
          this.notificationIsAddition = false;
          this.notificationIsUpdate = true;
          this.notificationItem = item;
          if (this.orderTreeIsOpen) {
            this.notificationItem = undefined;
          }
          this.generateUpsellBtnLabel();
          this.generateInfoMessage();
          this.upsellingSizeCalories = upsellingSizeCalories;

          if (this.dismissNotificationTimeout) {
            clearTimeout(this.dismissNotificationTimeout);
          }

          this.focusContinueShoppingButton();
        }),

      this.orderedItemService.updatedItem$
        .pipe(
          filter((item: OrderedItem) => !item.sizeUpsell && !item.ingredientUpsell),
          delay(this.DELAY)
        )
        .subscribe(() => {
          if (this.notificationItem) {
            this.dismissNotification();
          }
        }),

      this.orderSpecialService.addedSpecial$
        .pipe(
          switchMap(special => {
            this.notificationSpecial = special;

            this.focusContinueShoppingButton();

            const biggestNoticePeriod = special.items.reduce((max, item) => {
              return item.noticePeriod > max ? item.noticePeriod : max;
            }, 0);

            if (
              biggestNoticePeriod <= this.order?.noticePeriod ||
              !this.hasCateringNoticeTime ||
              (this.groupOrder?.isActive && !this.groupOrder?.asLeader)
            ) {
              return of({ special, timeslots: [] });
            }

            return this.orderService.order$.pipe(
              skip(1),
              take(1),
              switchMap(freshOrder =>
                this.resolveNoticePeriodTimeslots(freshOrder.noticePeriodDate).pipe(map(timeslots => ({ special, timeslots })))
              )
            );
          }),
          switchMap(({ special, timeslots }) => {
            if (!timeslots?.length) {
              return of({ special, updated: false });
            }

            const timeslotDate = parseISO(timeslots[0]);
            const deferTimeDate = parseISO(this.order.deferTime);

            const isLater = this.order.deferTime ? timeslotDate.getTime() > deferTimeDate.getTime() : true;

            const todayDate = Utils.getTzDate();
            const closeTime = this.deferService.storeStatus?.closeTime;
            const isNextDay = closeTime ? timeslotDate > parseISO(closeTime) : timeslotDate.toDateString() !== todayDate.toDateString();

            if (isNextDay) {
              this.deferTimeWeekdayName = formatInTimeZone(timeslotDate, this.timezoneService.getTimeZone(), 'EEEE');
            }

            const biggestNoticePeriod = special.items.reduce((max, item) => {
              return item.noticePeriod > max ? item.noticePeriod : max;
            }, 0);

            if (isLater && biggestNoticePeriod > 0) {
              const orderCopy = this.order ? this.order.copy() : new Order();
              orderCopy.deferTime = timeslots[0];
              this.updatedOrderDeferTime = format(timeslotDate, 'h:mm a');

              if (this.order.isInitialized && !this.groupOrder?.isActive) {
                return this.orderService.updateOrder(orderCopy).pipe(map(() => ({ special, updated: true })));
              } else {
                if (this.order.isInitialized && this.groupOrder?.asLeader) {
                  return this.orderService.updateOrder(orderCopy).pipe(map(() => ({ special, updated: true })));
                }
              }
            }

            return of({ special, updated: false });
          })
        )
        .subscribe(),
      this.orderSpecialService.addedSpecial$.pipe(delay(this.DELAY)).subscribe((_: any) => (this.notificationSpecial = undefined)),

      this.orderService.orderCreated$
        .pipe(
          map((order: Order) => order.pendingSpecial),
          filter(special => !!special),
          map((special: OrderableCoupon) => Coupon.fromOrderableCoupon(special))
        )
        .subscribe(coupon => {
          if (coupon) {
            this.notificationCoupon = coupon;

            if (!!coupon.instructions) {
              this.showCouponInstructionsBtn = true;
            }

            this.focusContinueShoppingButton();
          }
        }),
    ];
  }

  private fetchTimeSlots(day: string, deferOptions?: DeferOptions): Observable<string[]> {
    if (!day) {
      return EMPTY;
    }
    return this.deferService.getTimeSlots(day, this.order.orderType, deferOptions);
  }

  private resolveNoticePeriodTimeslots(noticePeriodDate: string | undefined): Observable<string[]> {
    const today = Utils.getTzDate();
    if (noticePeriodDate) {
      const npDate = parseISO(noticePeriodDate);
      const tomorrow = addDays(today, 1);
      if (npDate > tomorrow) {
        return this.fetchTimeSlots(noticePeriodDate, DeferOptions.Future).pipe(
          map(futureSlots => (futureSlots.length > 0 ? futureSlots : [noticePeriodDate]))
        );
      }
    }

    return this.fetchTimeSlots(formatISO(today), DeferOptions.Today).pipe(
      switchMap(todaySlots => {
        if (todaySlots.length > 0) {
          return of(todaySlots);
        }

        const targetDate = noticePeriodDate ? noticePeriodDate : formatISO(addDays(today, 1));

        return this.fetchTimeSlots(targetDate, DeferOptions.Future).pipe(
          map(futureSlots => {
            if (futureSlots.length > 0) {
              return futureSlots;
            }
            if (noticePeriodDate) {
              return [noticePeriodDate];
            }
            return [];
          })
        );
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions?.forEach(s => s.unsubscribe());
    this.upsellIngredientSubscription?.unsubscribe();
  }

  private focusContinueShoppingButton(): void {
    this.cdRef.detectChanges();
    setTimeout(() => {
      if (this.notificationWrapper?.nativeElement) {
        this.focusService.activateFocusTrap(this.notificationWrapper.nativeElement);
        if (this.continueShoppingBtn?.nativeElement) {
          this.continueShoppingBtn.nativeElement.focus();
        } else {
          this.notificationWrapper.nativeElement.focus();
        }
      }
    }, 0);
  }

  onCheckoutNotificationClick() {
    this.auditService.createAudit(() => 'Notification "CHECKOUT" button clicked.');
    this.toggleOrderTree();
  }

  onContinueShoppingClick() {
    this.auditService.createAudit(() => 'Notification "CONTINUE SHOPPING" button clicked.');
    this.dismissNotification();
    if (!(this.theme.minifiedMenu && this.viewport.isMobile)) {
      this.uiOrchestrationService.openMenuCategories();
    }
    if (this.theme.shouldShowTiledMenu) {
      this.router.navigate(['/menu']);
    }
  }

  toggleOrderTree() {
    this.dismissNotification();
    this.uiOrchestrationService.setOrderTreeShown();
    this.uiOrchestrationService.setOrderTreeIsOpen(true);
  }

  modifyItem() {
    this.auditService.createAudit(() => 'Notification "Modify Item" button clicked.');
    this.itemEditorService.editOrderedItem(this.notificationItem);
    this.dismissNotification();
  }

  onDismissNotificationClick() {
    this.auditService.createAudit(() => 'Dismiss notification "X" button clicked.');
    this.dismissNotification();
  }

  dismissNotification() {
    this.focusService.deactivateFocusTrap();
    this.notificationItem = undefined;
    this.notificationSpecial = undefined;
    this.notificationIsAddition = false;
    this.notificationIsUpdate = false;
    this.upsellingSizeCalories = undefined;
    this.showUpsizeDoneMessage = false;
    this.showUpingredientDoneMessage = false;
    this.hideIngrUpsellAfterSizeUp = false;
    this.updatedOrderDeferTime = '';
    this.deferTimeWeekdayName = '';
    this.clearCouponNotification();
  }

  clearOldMessagesNotifs() {
    this.upsellingSizeCalories = undefined;
    this.showUpsizeDoneMessage = false;
    this.showUpingredientDoneMessage = false;
    this.hideIngrUpsellAfterSizeUp = false;
    this.updatedOrderDeferTime = '';
    this.deferTimeWeekdayName = '';
  }

  upsellBtnClick(item: OrderedItem) {
    this.auditService.createAudit(() => `Notification "${this.upsellBtnLabel}" button clicked.`);
    if (item.sizeUpsell) {
      this.upsellSize(item);
    } else {
      this.upsellIngredient(item);
    }
  }

  handleCouponInstructionsBtnClick() {
    this.auditService.createAudit(() => `"View Instructions" button clicked.`);
    this.modalService.openCouponInstructionsModal(this.notificationCoupon);
  }

  @HostListener('document:click', ['$event'])
  protected onClick(event): void {
    this.clearOldMessagesNotifs();
    if (this.notificationWrapper && !this.notificationWrapper.nativeElement.contains(event.target)) {
      this.dismissNotification();
    }
  }

  private upsellSize(item: OrderedItem) {
    if (this.dismissNotificationTimeout) {
      clearTimeout(this.dismissNotificationTimeout);
      this.dismissNotificationTimeout = null;
    }

    const cachedItem = item.copy();
    this.hideIngrUpsellAfterSizeUp = true;
    item.size = item.sizeUpsell.size;
    item.isUpsell = true;
    item.upsellType = UpsellType.SIZE_BASED;
    this.uiOrchestrationService.disableCheckoutButton(true);
    this.orderUpsellService.getOrderableFromOrdered(item).subscribe(orderable => {
      const sizePrice = orderable.getSizePrice(item.size);
      item.noticePeriod = sizePrice?.noticePeriod;
    });

    this.orderedItemService
      .updateItem(item)
      .pipe(
        switchMap(updatedItem => {
          this.gtmService.pushRemoveFromCartEvent({
            items: [cachedItem],
            triggeringArea: EcommerceTriggeringArea.UPSELL,
            triggeringPoint: UpsellType.SIZE_BASED,
          });
          this.gtmService.pushAddToCartEvent({
            items: [updatedItem],
            triggeringArea: EcommerceTriggeringArea.UPSELL,
            triggeringPoint: UpsellType.SIZE_BASED,
          });

          this.showUpsizeDoneMessage = true;
          this.notificationIsAddition = false;
          this.notificationIsUpdate = true;
          this.generateInfoMessage();
          this.auditService.createAudit(() => `${item.item} size has been updated to ${item.size}`);
          this.uiOrchestrationService.disableCheckoutButton(false);

          return of(updatedItem);
        }),
        switchMap(item => {
          if (
            item?.noticePeriod <= cachedItem?.noticePeriod ||
            !this.hasCateringNoticeTime ||
            (this.groupOrder?.isActive && !this.groupOrder?.asLeader)
          ) {
            return of({ item: item, timeslots: [] });
          }

          return this.resolveNoticePeriodTimeslots(this.order.noticePeriodDate).pipe(map(timeslots => ({ item, timeslots })));
        }),
        switchMap(({ item, timeslots }) => {
          if (!timeslots?.length) {
            return of({ item, updated: false });
          }

          const timeslotDate = parseISO(timeslots[0]);
          const deferTimeDate = parseISO(this.order.deferTime);

          const isLater = this.order.deferTime ? timeslotDate.getTime() > deferTimeDate.getTime() : true;

          const todayDate = Utils.getTzDate();
          const closeTime = this.deferService.storeStatus?.closeTime;
          const isNextDay = closeTime ? timeslotDate > parseISO(closeTime) : timeslotDate.toDateString() !== todayDate.toDateString();

          if (isNextDay) {
            this.deferTimeWeekdayName = formatInTimeZone(timeslotDate, this.timezoneService.getTimeZone(), 'EEEE');
          }

          if (isLater && item?.noticePeriod > 0) {
            const orderCopy = this.order ? this.order.copy() : new Order();
            orderCopy.deferTime = timeslots[0];
            this.updatedOrderDeferTime = format(parseISO(timeslots[0]), 'h:mm a');

            if (this.order.isInitialized && !this.groupOrder?.isActive) {
              return this.orderService.updateOrder(orderCopy).pipe(map(() => ({ item, updated: true })));
            } else {
              if (this.order.isInitialized && this.groupOrder?.asLeader) {
                return this.orderService.updateOrder(orderCopy).pipe(map(() => ({ item, updated: true })));
              }
            }
          }

          return of({ item, updated: false });
        })
      )
      .subscribe();
  }

  private upsellIngredient(item: OrderedItem) {
    if (this.dismissNotificationTimeout) {
      clearTimeout(this.dismissNotificationTimeout);
      this.dismissNotificationTimeout = null;
    }
    const ingredientUpsell = item.ingredientUpsell;
    const orderableItemLink = !!this.hypermedia.findLink(item.links, 'orderableItem')
      ? this.hypermedia.findLink(item.links, 'orderableItem').href
      : undefined;

    this.upsellIngredientSubscription = this.http
      .get(orderableItemLink)
      .pipe(
        map(json => new OrderableItem().deserialize(json)),
        mergeMap(orderableItem => {
          const insChoice = orderableItem.choices.filter(
            choice => choice.ingredients.map(ingredient => ingredient.name).indexOf(ingredientUpsell.ingredient) !== -1
          )[0];
          const insChoiceName = !!insChoice ? insChoice.name : undefined;
          const insIngredient = []
            .concat(...orderableItem.choices.map(choice => choice.ingredients))
            .filter(ingredient => ingredient.name === ingredientUpsell.ingredient)[0];
          const orderedIngredient = this.orderedIngredientService.createOrderedIngredient(insIngredient);
          item.choices[item.choices.map(choice => choice.name).indexOf(insChoiceName)].ingredients.push(orderedIngredient);
          item.isUpsell = true;
          item.upsellType = UpsellType.INGREDIENT;
          this.uiOrchestrationService.disableCheckoutButton(true);
          return of(item);
        }),
        mergeMap(upselledItem => {
          return this.orderedItemService.updateItem(upselledItem);
        })
      )
      .subscribe(upselledItem => {
        this.showUpingredientDoneMessage = true;
        this.notificationIsAddition = false;
        this.notificationIsUpdate = true;
        this.generateInfoMessage();
        this.auditService.createAudit(() => `Added ingredient ${ingredientUpsell.ingredient} to item ${upselledItem.item}`);
        this.uiOrchestrationService.disableCheckoutButton(false);
      }, noop);
  }

  private findUpsellingSizePriceCalories(item: OrderedItem, orderableItem: OrderableItem): Observable<string | null> {
    if (item.sizeUpsell) {
      return this.configService.storeConfig$.pipe(
        mergeMap((config: StoreConfig) => {
          if (config.showCalories && config.showCaloriesForSizeUpsells && orderableItem) {
            return of(orderableItem.sizePrices.find(s => s.size === item.sizeUpsell.size));
          }
          return of(null);
        }),
        map((sizePrice: SizePrice) => {
          if (sizePrice) {
            const caloriesTextChunks = [];
            const caloriesPerServing = this.orderableItemService.getItemCaloriesPerServing(sizePrice);
            if (!Utils.isNullOrUndefined(caloriesPerServing)) {
              caloriesTextChunks.push(
                `${caloriesPerServing} ${this.translateService.instant('component.order_notification.cal_per')} ${sizePrice.servingsLabel}`
              );
            } else {
              return null;
            }

            const servings = this.orderableItemService.getServings(sizePrice);
            if (!Utils.isNullOrUndefined(servings)) {
              caloriesTextChunks.push(
                `${servings} ${this.translateService.instant('component.order_notification.for')} ${item.sizeUpsell.size}`
              );
            }
            return caloriesTextChunks.join(' / ');
          }
        })
      );
    }
    return of(null);
  }

  private generateInfoMessage() {
    if (this.notificationItem) {
      const haveVerb =
        this.notificationItem.requestedQuantity > 1 ? 'component.order_notification.have' : 'component.order_notification.has';
      const action = this.notificationIsAddition
        ? 'component.order_notification.added_to_order'
        : 'component.order_notification.updated_order';
      this.infoMessage = `${this.translateService.instant(haveVerb)} ${this.translateService.instant(action)}`;
    }
  }

  private generateUpsellBtnLabel() {
    if (!this.notificationItem) {
      return;
    }

    if (this.notificationItem.sizeUpsell) {
      if (this.notificationItem.sizeUpsell.priceDiff > 0) {
        this.upsellBtnLabel = this.translateService.instant('component.order_notification.make_it', {
          size: this.notificationItem.sizeUpsell.sizeLabel,
          price: this.currencyPipe.transform(this.notificationItem.sizeUpsell.priceDiff, 'USD', 'symbol'),
        });
      } else {
        this.upsellBtnLabel = this.translateService.instant('component.order_notification.make_it_for_free', {
          size: this.notificationItem.sizeUpsell.sizeLabel,
        });
      }

      return;
    }
    if (this.notificationItem.ingredientUpsell) {
      if (this.notificationItem.ingredientUpsell.priceDiff > 0) {
        this.upsellBtnLabel = this.translateService.instant('component.order_notification.add_ingredient', {
          ingredient: this.notificationItem.ingredientUpsell.ingredient,
          price: this.currencyPipe.transform(this.notificationItem.ingredientUpsell.priceDiff, 'USD', 'symbol'),
        });
      } else {
        this.upsellBtnLabel = this.translateService.instant('component.order_notification.add_ingredient_for_free', {
          ingredient: this.notificationItem.ingredientUpsell.ingredient,
        });
      }
    }
  }

  private clearCouponNotification() {
    this.notificationCoupon = undefined;
    this.showCouponInstructionsBtn = false;
  }
}
